import { render } from "./FootView.vue?vue&type=template&id=4a622f6b&scoped=true&ts=true"
import script from "./FootView.vue?vue&type=script&lang=ts"
export * from "./FootView.vue?vue&type=script&lang=ts"

import "./FootView.vue?vue&type=style&index=0&id=4a622f6b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a622f6b"]])

export default __exports__